var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('h1',[_vm._t("title",[_vm._v("ページのタイトル")])],2),_c('div',[_vm._t("content",[_vm._v("コンテンツ")])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }